const PARTITIONS_CACHE = {};

export function getDataFromCache(layerId, version, partitionId) {
  return PARTITIONS_CACHE[`${layerId}-${version || null}-${partitionId}`];
}

export function storeDataToCache(layerId, version, partitionId, data) {
  PARTITIONS_CACHE[`${layerId}-${version || null}-${partitionId}`] = data;
}
